import { BaseService } from 'core/services';
import ScheduleDateViewRouteService from './ScheduleDateViewRouteService';

class ScheduleDateViewService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new ScheduleDateViewRouteService());
    }

}

export default ScheduleDateViewService;
